import React, { Component } from 'react'
import InputRow from './InputRow'
import Loading from './Loading'
import PropTypes from 'prop-types'
export default class Sources extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      error: '',
      sourceData: [],
      selectedSources: [],
      otherSource: this.props.otherSource ? this.props.otherSource : ''
    }
  }

  componentDidMount () {
    fetch(`${process.env.REACT_APP_API_URL}/api/source/getsources`)
      .then(res => res.json())
      .then(res => {
        if (res.length) {
          this.setState({ sourceData: res, loading: false })
        }
        if (this.props.sources.length) {
          const newSource = []
          this.props.sources.forEach(element => {
            newSource.push(element.Id)
          })
          this.setState({ selectedSources: newSource })
        }
      })
      .catch(err => console.log(err))
  }

  render () {
    const {
      loading,
      sourceData,
      selectedSources,
      otherSource
    } = this.state
    if (loading) {
      return (<Loading />)
    }
    // eslint-disable-next-line prefer-const
    let displaySources = []
    sourceData.forEach((element, index) => {
      displaySources.push(
        <label key={index}>
          <input
            type="checkbox"
            value={element.Id}
            name="sources"
            checked={selectedSources.indexOf(element.Id) !== -1}
            onChange={(e) => {
              if (selectedSources.indexOf(parseInt(e.target.value)) === -1) {
                this.props.collectState('Sources', {
                  selectedSources: [...this.state.selectedSources, parseInt(e.target.value)],
                  otherSource: otherSource
                })
                this.setState({ selectedSources: [...this.state.selectedSources, parseInt(e.target.value)] })
              } else {
                const newSources = []
                selectedSources.forEach(element => {
                  if (element !== parseInt(e.target.value)) {
                    newSources.push(parseInt(element))
                  }
                })
                this.setState({ selectedSources: newSources })
                this.props.collectState('Sources', {
                  selectedSources: newSources
                })
              }
            }}
          />
          {element.value}

        </label>
      )
    })
    return (
      <div className="sources-section">
        <p>Where did you hear about us ?</p>
        <div>
          {displaySources}
        </div> 
        <InputRow
          name="text"
          rowName="If others, please specify"
          value={otherSource}
          required = {selectedSources.includes(16) ? '*' : ''}
          //errMsg={validationError.selectedSecondLevel ? validationError.selectedSecondLevel : ''}
          disabled= {selectedSources.includes(16) ? false : true} //16 is the Id of "Other" value
          onChange={(e) => {
            this.props.collectState('Sources', {
              selectedSources: selectedSources,
              otherSource: e
            })
            this.setState({ otherSource: e })
          }}
        />
        {this.props.error.general && <p style={{ color: 'red', fontSize: 12, marginTop: 3, marginBottom: 5, }}>{this.props.error.general}</p>}
        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>

      </div>
    )
  }
}
Sources.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  sources: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
  otherSource: PropTypes.string
}
